import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { ConfigService} from './environments/environment';
import { Integrations } from "@sentry/tracing";
import * as Sentry from "@sentry/angular";

// Sentry.init({
//   dsn: "https://ea699a22d81b496ebf49aa6a089f328b@o1001414.ingest.sentry.io/5960941",
//   integrations: [
//     new Integrations.BrowserTracing({
//       tracingOrigins: ["localhost", "https://yourserver.io/api"],
//       routingInstrumentation: Sentry.routingInstrumentation,
//     }),
//   ],

//   // Set tracesSampleRate to 1.0 to capture 100%
//   // of transactions for performance monitoring.
//   // We recommend adjusting this value in production
//   tracesSampleRate: 1.0,
// });


// I don't think this will work since this is prior to the Angular application bootstrap
if (ConfigService.config?.production) {
  enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
